export default function brand_details()
{
    return({
        //Company Information
        name: "INFINITY",
        subtitle: "",
        sub_entity_name: "Centres",
        
        //Logo Information
        logo:getComputedStyle(document.documentElement)
        .getPropertyValue("--brand-logo")
        .replace(/['"]+/g, "")
    });
}